import React, { useEffect } from 'react';
import './AdPlaceholder.css';

const AdPlaceholder = ({ position }) => {
  useEffect(() => {
    try {
      // Push ad if Google AdSense is loaded
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, []);

  const getAdSize = () => {
    switch (position) {
      case 'top':
      case 'bottom':
        return 'banner';
      case 'sidebar':
        return 'sidebar';
      default:
        return 'banner';
    }
  };

  const getAdSlot = () => {
    // You'll need to create ad units in AdSense and replace these with your actual ad slot IDs
    switch (position) {
      case 'top':
        return 'YOUR_TOP_AD_SLOT_ID';
      case 'bottom':
        return 'YOUR_BOTTOM_AD_SLOT_ID';
      case 'sidebar':
        return 'YOUR_SIDEBAR_AD_SLOT_ID';
      default:
        return 'YOUR_DEFAULT_AD_SLOT_ID';
    }
  };

  return (
    <div className={`ad-placeholder ad-${position} ad-${getAdSize()}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1263220886214878"
        data-ad-slot={getAdSlot()}
        data-ad-format={getAdSize() === 'banner' ? 'horizontal' : 'rectangle'}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdPlaceholder;

